function subscribe(eventName: string, listener: (_: any) => void) {
  document.addEventListener(eventName, listener);
}

function unsubscribe(eventName: string, listener: (_: any) => void) {
  document.removeEventListener(eventName, listener);
}

function publish(eventName: string, data?: any) {
  const event = new CustomEvent(eventName, { detail: data });
  document.dispatchEvent(event);
}

export const CLICK_DOCUMENT_EVENT = "clickDocument";

export { publish, subscribe, unsubscribe };
